import type React from 'react'

export interface ProjListItem {
	id: string
	title: string
	excerpt?: string
	meta: string
	href: string
	external?: boolean
}

interface ProjListProps {
	items: ProjListItem[]
	fallback?: React.ReactNode
}

const ROW_BASE =
	'grid grid-cols-[auto_1fr] md:grid-cols-[80px_1fr_240px_64px] gap-4 md:gap-8 px-7 py-8 border-b-2 border-ink last:border-b-0 items-center ' +
	'hover:bg-hazard hover:pl-10 transition-[padding,background] duration-150 focus-ring'

export function postNum(i: number) {
	return String(i + 1).padStart(2, '0')
}

export function formatDate(dateStr: string) {
	return new Date(dateStr)
		.toLocaleDateString('en-AU', { year: 'numeric', month: 'short' })
		.toUpperCase()
}

export function ProjList({ items, fallback }: ProjListProps): React.ReactElement {
	return (
		<div className="max-w-[1600px] bg-paper border-2 border-ink">
			{items.length > 0
				? items.map((item, i) => (
						<a
							key={item.id}
							href={item.href}
							{...(item.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
							className={ROW_BASE}
						>
							<span className="font-display-cond text-4xl font-black leading-none tracking-[-0.02em] text-ink">
								{postNum(i)}
							</span>
							<span className="font-display font-extrabold uppercase text-[28px] leading-[1.1] text-ink">
								{item.title}
								{item.excerpt && (
									<span className="block font-serif font-medium normal-case not-italic italic text-[15px] text-ink-dim mt-1.5 leading-[1.45]">
										{item.excerpt}
									</span>
								)}
							</span>
							<span className="font-mono text-[11px] uppercase text-ink-2 font-medium">
								{item.meta}
							</span>
							<span className="font-display-cond text-[32px] font-black text-right text-ink">→</span>
						</a>
					))
				: fallback ?? null}
		</div>
	)
}
